import { render } from "./file-share-list.vue?vue&type=template&id=caaa8852&lang=pug"
import script from "./file-share-list.vue?vue&type=script&lang=js"
export * from "./file-share-list.vue?vue&type=script&lang=js"

import "./file-share-list.vue?vue&type=style&index=0&id=caaa8852&lang=scss"

import exportComponent from "C:\\m-tech\\WMExtranet2.0\\WebUI\\WiseApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__